import { useEffect, useState } from "react";
import { AppBox, AppPaper, AppSkeletonListComponent, AppText, AppTitle } from "../../../commons/components";
import { useAppDispatch, useAppSelector } from "../../../hooks/app";
import { StatusEnum } from "../../../commons/enums/status-enum";
import {
  fetchManageCompetitionSeasonStanding,
  IManageFootballStandingOption,
} from "../../../redux/slices/football/admin/competition/manage-competition-season-standing-slice";
import { groupStandings, IGroupedStanding } from "../../../commons/utilities/standing-table-utils";
import StandingTableGroup from "../../../commons/components/ui-components/StandingTableGroup";
import AppBorderBox from "../../../commons/components/BorderBox";
import IconEmpty from "../../../commons/components/icons/empty";
import { IFootballHostedCompetition } from "../../../commons/models/football/interface/i-football-competition";

export default function TournamentManageStandings() {
  const dispatch = useAppDispatch();
  const { competitionInfoStatus } = useAppSelector((state) => state.footballManageCompetition);
  const { hostedCompetitionInfoStatus } = useAppSelector((state) => state.footballManageHostedCompetitionDetail);
  const { fetchedCompetition } = useAppSelector((state) => state.fetchedCompetition);
  const { seasonList } = useAppSelector((state) => state.footballManageCompetitionSeason);
  const { selectedGlobalSeasonOption } = useAppSelector((state) => state.globalSeasonSelect);
  const { standingListByPoint, standingStatus } = useAppSelector(
    (state) => state.footballManageCompetitionSeasonStanding
  );
  const [groupedStandings, setGroupedStandings] = useState<IGroupedStanding[]>([]);

  useEffect(() => {
    if (selectedGlobalSeasonOption.value && fetchedCompetition.id) {
      const standingsOption: IManageFootballStandingOption = {
        competitionId: Number(fetchedCompetition.id),
        seasonId: Number(selectedGlobalSeasonOption.value),
        urlParams: {
          hostTeamId: (fetchedCompetition as IFootballHostedCompetition).hostTeam?.id,
        },
      };
      dispatch(fetchManageCompetitionSeasonStanding(standingsOption));
    }
  }, [selectedGlobalSeasonOption]);

  useEffect(() => {
    setGroupedStandings(groupStandings(standingListByPoint));
  }, [standingListByPoint]);

  return (
    <AppBox mb="sm" flexDirection="column" gap="xs">
      {(competitionInfoStatus === StatusEnum.Succeeded || hostedCompetitionInfoStatus === StatusEnum.Succeeded) && (
        <AppBox flexDirection="column" gap="xs">
          <AppTitle as="h5">Standings</AppTitle>
        </AppBox>
      )}
      {seasonList.data.length > 0 ? (
        <>
          {standingStatus === StatusEnum.Loading ? (
            <AppSkeletonListComponent numberOfItems={20} noTitle />
          ) : (
            <>
              {groupedStandings.length > 0 ? (
                <StandingTableGroup groupedStandings={groupedStandings} isManage />
              ) : (
                <AppText>No standing data for the season.</AppText>
              )}
            </>
          )}
        </>
      ) : (
        <AppPaper padding="sm">
          <AppBorderBox borderVariant="dashed">
            <AppBox flexDirection="column" alignItems="center" gap="sm" justifyContent="center" p="sm">
              <AppBox alignItems="center" flexDirection="column" justifyContent="center" gap="xs">
                <IconEmpty width={56} height={56} color="rgba(var(--border-200))" />
                <AppText fontWeight="semibold">
                  To get the standings, you need to start the season first. Click the "Start Season" button above to
                  begin.
                </AppText>
              </AppBox>
            </AppBox>
          </AppBorderBox>
        </AppPaper>
      )}
    </AppBox>
  );
}
